<template>
  <div class="add-modify">
    <el-form :model="form" ref="form" :rules="rules2" label-position="left" label-width="0" class="card-add-modify">
      <el-row class="add-modify-row">
        <el-col :span="8" class="add-modify-label-small" style="height: 4em">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="width: 140px">得意先コード</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" class="add-modify-input-samll add-modify-padding">
          <el-form-item prop="userId" >
            <el-input type="text" id="userId" class="add-modify-el-input-samll" v-model="form.userId"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="add-modify-row">
        <el-col :span="8" class="add-modify-label-small" style="height: 4em">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="width: 140px;">会社名</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" class="add-modify-input-samll add-modify-padding">
          <el-form-item prop="company_name" >
            <el-input type="text" class="add-modify-el-input-samll" v-model.trim="form.company_name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="add-modify-row">
        <el-col :span="8" class="add-modify-label-nomal">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="width: 140px">担当名</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" class="add-modify-input add-modify-padding">
          <el-row>
            <el-col :span="12">
              <div class="add-modify-namae">姓</div>
            </el-col>
            <el-col :span="12">
              <div class="add-modify-namae">名</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="namesei" class="add-modify-padding">
                <el-input type="text" style="width: 150px;" v-model="form.namesei" value = 'this.form.namesei'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="namemei" class="add-modify-padding">
                <el-input type="text" style="width: 150px;" v-model="form.namemei"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8"class="add-modify-label-nomal">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="24">
              <div style="width: 180px">フリガナ</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" class="add-modify-mail-input add-modify-padding">
          <el-row>
            <el-col :span="12">
              <div class="add-modify-namae">姓（カタカナ）</div>
            </el-col>
            <el-col :span="12">
              <div class="add-modify-namae">名（カタカナ）</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="kanasei" class="add-modify-padding">
                <el-input type="text" style="width: 150px;" v-model="form.kanasei"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="kanamei" class="add-modify-padding">
                <el-input type="text" style="width: 150px;" v-model="form.kanamei"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="margin-top: 0.2em;margin-bottom: 0.2em">
        <el-col :span="8" style="height: 150px;padding: 1em 2em 1.2em 2em;background-color:#E2EBFF; ">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row style="width: 150px">
            <el-col :span="24">
              <div>メールアドレス</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" style="height: 150px;background-color:#F5F7F7;">
          <el-row>
            <el-col :span="24" >
              <el-form-item prop="mail1" style='height: 60px' class="add-modify-padding">
                <el-input type="text" style="width: 80%" class="add-modify-padding" v-model="form.mail1"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3" >
              <div style="margin-left: 10px">再入力</div>
            </el-col>
            <el-col :span="21" >
              <el-form-item prop="remail1" style='height: 60px' class="add-modify-padding">
                <el-input type="text" style="width: 90%" v-model="form.remail1"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

      </el-row>
      <el-row style="margin-top: 0.2em;margin-bottom: 0.2em">
        <el-col :span="8" style="height: 150px;padding: 1em 2em 1.2em 2em;background-color:#E2EBFF; ">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row style="width: 150px">
            <el-col :span="24">
              <div>パスワード</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" style="height: 150px;background-color:#F5F7F7; ">
          <el-row>
            <el-col :span="24" >
              <el-form-item prop="password" style='height: 60px' class="add-modify-padding">
                <el-input type="password" style="width: 80%" class="add-modify-padding" v-model="form.password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3" >
              <div style="margin-left: 10px">再入力</div>
            </el-col>
            <el-col :span="21" >
              <el-form-item prop="repassword" style='height: 60px' class="add-modify-padding">
                <el-input type="password" style="width: 90%" v-model="form.repassword"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

      </el-row>
      <el-row class="add-modify-row">
        <el-col :span="8" class="add-modify-label-small" style="height: 75px">
          <el-row style="width: 140px">
            <el-col :span="24">
              <div class="login-integrant">必須</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div style="width: 140px">電話番号</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16" class="add-modify-input-samll" style="margin-top: 5px;height: 70px">
          <el-row >
            <el-col :span="8">
              <el-form-item prop="telNumber1" class="add-modify-padding">
                <el-input type="text" style="width: 70%;" id = 'telNumber1' class="add-modify-padding" v-model="form.telNumber1" :maxlength = 4></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="telNumber2">
                <el-input type="text" style="width: 70%;" id = 'telNumber2' v-model="form.telNumber2" :maxlength = 4></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="telNumber3">
                <el-input type="text" style="width: 70%;" id = 'telNumber3' v-model="form.telNumber3" :maxlength= 4></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row style="text-align: center">
        <el-col :span="24">
          <el-form-item >
            <el-button type="danger" class="kakuninn-btn" v-on:click="handleSubmit2('form')">登 録</el-button>
            <el-button type="danger" v-on:click="back"><i class="el-icon-caret-right"style="color: white;width: 60px"></i>一　覧</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import { isUserId, isValidPwd, isName, isKana, isEmail, isTel, isTel2 } from '../../assets/js/check'
  import _g from '../../assets/js/global'

  export default {
    name: 'add',
    props: 'activeName',
    data() {
      var checkUserId = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('得意先コードを入力してください。'))
        } else if (!isUserId(value)) {
          callback(new Error('得意先コードは9桁を入力してください。'))
        } else {
          callback()
        }
      }
      var checkPassWord = (rule, value, callback) => {
        if (value == null || value == '') {
          callback(new Error('パスワードを入力してください。'))
        } else if (!isValidPwd(value)) {
          callback(new Error('パスワードは8桁～10桁の英数字混在を入力してください。'))
        } else {
          callback()
        }
      }
      var repassword = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('再度パスワードを入力してください。'))
        } else if (this.form.password !== value) {
          callback(new Error('パスワードが不一致ので、確認してください。'))
        } else {
          callback()
        }
      }
      var checkNamesei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('御担当名「姓」を入力してください。'))
        } else if (!isName(value)) {
          callback(new Error('御担当名「姓」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkNamemei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('御担当名「名」を入力してください。'))
        } else if (!isName(value)) {
          callback(new Error('御担当名「名」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkKanasei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('フリガナ「姓」を入力してください。'))
        } else if (!isKana(value)) {
          callback(new Error('フリガナ「姓」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkKanamei = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('フリガナ「名」を入力してください。'))
        } else if (!isKana(value)) {
          callback(new Error('フリガナ「名」を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkMail1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('メールアドレスを入力してください。'))
        } else if (!isEmail(value)) {
          callback(new Error('メールアドレスを正しく入力してください。'))
        } else {
          callback()
        }
      }
      var checkRemail1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('メールアドレス「再入力」を入力してください。'))
        } else if (this.form.mail1 !== value) {
          callback(new Error('2回の入力が一致しない！'))
        } else {
          callback()
        }
      }
      var telNumber1 = (rule, value, callback) => {
        if (value === null || value === '') {
          callback(new Error('電話番号を入力してください。'))
        } else if (!isTel(value)) {
          callback(new Error('電話番号を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var telNumber2 = (rule, value, callback) => {
        if (!isTel2(value)) {
          callback(new Error('電話番号を正しく入力してください。'))
        } else {
          callback()
        }
      }
      var telNumber3 = (rule, value, callback) => {
        if (this.form.telNumber2 !== null || this.form.telNumber2 !== '') {
          if (value === null || value === '') {
            callback(new Error('電話番号を入力してください。'))
          } else if (!isTel2(value)) {
            callback(new Error('電話番号を正しく入力してください。'))
          } else {
            callback()
          }
        } else {
          if (!isTel2(value)) {
            callback(new Error('電話番号を正しく入力してください。'))
          } else {
            callback()
          }
        }
      }
      return {
        form: {
          userId: '',
          company_name: '',
          namesei: '',
          namemei: '',
          kanasei: '',
          kanamei: '',
          mail1: '',
          remail1: '',
          password: '',
          repassword: '',
          telNumber1: '',
          telNumber2: '',
          telNumber3: ''
        },
        rules2: {
          userId: [
            { required: true, validator: checkUserId, trigger: 'blur' }
          ],
          company_name: [
            { required: true, message: '会社名を入力してください', trigger: 'blur' }
          ],
          namesei: [
            { required: true, validator: checkNamesei, trigger: 'blur' }
          ],
          namemei: [
            { required: true, validator: checkNamemei, trigger: 'blur' }
          ],
          kanasei: [
            { required: true, validator: checkKanasei, trigger: 'blur' }
          ],
          kanamei: [
            { required: true, validator: checkKanamei, trigger: 'blur' }
          ],
          mail1: [
            { required: true, validator: checkMail1, trigger: 'blur' }
          ],
          remail1: [
            { required: true, validator: checkRemail1, trigger: 'blur' }
          ],
          password: [
            { required: true, validator: checkPassWord, trigger: 'blur' }
          ],
          repassword: [
            { required: true, validator: repassword, trigger: 'blur' }
          ],
          telNumber1: [
            { required: true, validator: telNumber1, trigger: 'blur' }
          ],
          telNumber2: [
            { required: true, validator: telNumber2, trigger: 'blur' }
          ],
          telNumber3: [
            { required: true, validator: telNumber3, trigger: 'blur' }
          ]
        },
        tableData: []
      }
    },
    methods: {
      handleSubmit2(form) {
        var userId = window.localStorage.getItem('userId')
        this.$refs[form].validate((valid) => {
          if (valid) {
            var telNumber1 = ''
            var telNumber2 = ''
            var telNumber3 = ''
            if ((this.form.telNumber1.length + this.form.telNumber2.length + this.form.telNumber3.length) > 11 ||
              (this.form.telNumber1.length + this.form.telNumber2.length + this.form.telNumber3.length) < 10) {
              telNumber1 = document.getElementById('telNumber1')
              telNumber2 = document.getElementById('telNumber2')
              telNumber3 = document.getElementById('telNumber3')
              telNumber1.style.border = '1px solid #f56c6c'
              telNumber2.style.border = '1px solid #f56c6c'
              telNumber3.style.border = '1px solid #f56c6c'
              _g.toastMsg('error', '電話番号を正しく入力してください。')
              return
            } else {
              telNumber1 = document.getElementById('telNumber1')
              telNumber2 = document.getElementById('telNumber2')
              telNumber3 = document.getElementById('telNumber3')
              telNumber1.style.border = ''
              telNumber2.style.border = ''
              telNumber3.style.border = ''
            }
            let data = {}
            data.userId = this.form.userId
            data.company_name = this.form.company_name
            data.namesei = this.form.namesei
            data.namemei = this.form.namemei
            data.kanasei = this.form.kanasei
            data.kanamei = this.form.kanamei
            data.mail1 = this.form.mail1
            data.remail1 = this.form.remail1
            data.password = this.form.password
            data.repassword = this.form.repassword
            data.telNumber1 = this.form.telNumber1
            data.telNumber2 = this.form.telNumber2
            data.telNumber3 = this.form.telNumber3
            data.userId1 = userId
            this.apiPost('shanaikanrisha/ClientList/add', data).then((res) => {
              this.handelResponse(res, (data) => {
                if (res.code != 200) {
                  this.handleError(res)
                } else {
                  _g.toastMsg('success', '追加成功しました')
                  this.$emit('activeNameChg', 'list')
                }
              })
            })
          } else {
            return false
          }
        })
      },
      back: function() {
        this.$emit('activeNameChg', 'list')
        // this.resetCommonData('shanaikanrisha/clientList')
      }
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          return false
        }
      })
    },
    created() {
      window.load = function() {
        document.getElementById('userId').value = ''
        // document.getElementById('password').value = ''
        // table = document.getElementById('userId')
        // rows = table.getElementsByTagName('tr')
      }
    },
    mixins: [http]
  }
</script>
<style>
  @import url("../../assets/css/common.css");
  .card-add-modify {
    margin: auto;
    width: 50em;
  }
  .add-modify-row{
    margin-bottom: 0.1em;
  }
  .add-modify-label-small{
    height: 150px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .add-modify-input-samll{
    height: 40px;
    background-color:#F5F7F7;
  }
  .add-modify-padding {
    padding-left: 1em;
  }
  .add-modify-el-input-samll{
    margin: 10px 20px 0px 20px;
    width: 300px;

  }
  .add-modify-input{
    height: 110px;
    background-color:#F5F7F7;
  }
  .add-modify-namae{
    width: 140px;
    margin: 10px;
  }
  .add-modify-label-nomal{
    height: 150px;
    padding: 1em 2em 1.2em 2em;
    background-color:#E2EBFF;
  }
  .kakuninn-btn{
    margin-top: 0.5em;
    width: 150px;
  }
</style>
<style>
  .add-modify .el-form-item__error{
    left: 4%;
  }
  .add-modify .el-input__inner{
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/add.vue